'use client';

import React, { useState } from 'react';
import PropTypes from 'prop-types';
import ClinicList from './ClinicList';
import ClinicMap from './ClinicMap';
import LoaderSVG from '../../../../static/images/circle-loader.svg';


ClinicResults.propTypes = {
    selectedAddress: PropTypes.shape({
        address: PropTypes.string,
        lat: PropTypes.number,
        lng: PropTypes.number,
    }),
    clinicData: PropTypes.array,
    loading: PropTypes.bool,
    fitMarkers: PropTypes.bool,
};

export default function ClinicResults({ clinicData, selectedAddress, loading, fitMarkers }) {
    const [curTab, setCurTab] = useState('map');

    function changeTab(e, tab) {
        e.preventDefault();
        setCurTab(tab)
    }

    return (
        <>
            <div className="clinic-finder__results">

                {loading && (
                    <div className="clinic-finder__result-loader">
                        <img src={LoaderSVG} alt="loading" />
                    </div>
                )}

                <div className="clinic-finder__tabs">
                    <span className={`clinic-finder__tab ${curTab == 'map' ? 'is-active' : ''}`} onClick={(e) => changeTab(e, 'map')}>Map</span>
                    <span className={`clinic-finder__tab ${curTab == 'list' ? 'is-active' : ''}`} onClick={(e) => changeTab(e, 'list')}>List</span>
                </div>

                <ClinicMap
                    selectedAddress={selectedAddress}
                    results={clinicData}
                    curTab={curTab}
                    fitMarkers={fitMarkers}
                />

                <ClinicList results={clinicData} curTab={curTab} />

            </div>

        </>
    );
}
